import { BlogDetailTitleElementDataType } from '@/components/sections/builder/elements/body/blog-detail/type';
import PaddingSetting from '@/components/sections/builder/settings/padding-setting';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export default function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as BlogDetailTitleElementDataType;

  return (
    <div>
      <PaddingSetting
        hideLeft={true}
        hideRight={true}
        value={data.padding}
        onChange={(v) => builder.setElementData(element.id, { padding: v })}
      />
      <div className='mb-2 mt-4 font-bold'>Color scheme</div>
      <SchemeSetting
        value={data.colorSchemeSection}
        onChange={(theme) => {
          builder.setElementData(element.id, {
            colorSchemeSection: theme,
          });
        }}
      />
    </div>
  );
}
